import { useCallback, useEffect, useMemo } from 'react';

import { getRecordKeyFor } from '~/reducers/customerCommunicationReducer';

import fetchHeroPlannerCountryGroups from '~/actions/customerCommunication/fetchHeroPlannerCountryGroups';

import { useAppDispatch, useAppSelector } from '../store';

function useHeroPlannerCountryGroups(brand?: string) {
  const [key, params] = useMemo(() => {
    const params: Parameters<typeof fetchHeroPlannerCountryGroups> = [brand];
    return [getRecordKeyFor(...params), params];
  }, [brand]);
  const countryGroupsReq = useAppSelector((state) => state.customerCommunication.countryGroupRecords[key]);
  const appDispatch = useAppDispatch();
  const fetchCountryGroups = useCallback(() => {
    appDispatch(fetchHeroPlannerCountryGroups(...params));
  }, [appDispatch, params]);
  useEffect(() => {
    fetchCountryGroups();
  }, [fetchCountryGroups]);

  return { countryGroupsReq, fetchCountryGroups };
}

export default useHeroPlannerCountryGroups;
